export const blockIconsDeviceBluetooth = (
	<span className='material-symbols-outlined'>bluetooth</span>
);
